import { deleteFeeLevels } from "actions/Utilities/FeeLevel";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useDeleteFeeLevel = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids: string[]) => deleteFeeLevels(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetFeeLevels"]);
      toast.fire(
        "Success",
        "Fee Level were deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Fee Level failed",
        "Server Error: Cannot deactivate Fee Level",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteFeeLevel;
